export type AthleteModelStyle = 'realistic' | 'legacy';

export const ATHLETE_MODEL_QUERY_KEY = 'athlete';
export const DEFAULT_ATHLETE_MODEL_STYLE: AthleteModelStyle = 'realistic';

export const resolveAthleteModelStyle = (
  search = typeof window === 'undefined' ? '' : window.location.search,
): AthleteModelStyle => {
  const requested = new URLSearchParams(search).get(ATHLETE_MODEL_QUERY_KEY);
  return requested === 'legacy' || requested === 'tubes'
    ? 'legacy'
    : DEFAULT_ATHLETE_MODEL_STYLE;
};

export const athleteModelComparisonHref = (
  href: string,
  style: AthleteModelStyle,
): string => {
  const url = new URL(href, 'http://decathlon.local');
  url.searchParams.set(ATHLETE_MODEL_QUERY_KEY, style);
  return `${url.pathname}${url.search}${url.hash}`;
};

export const mountAthleteModelSwitcher = (): (() => void) => {
  const previous = document.querySelector<HTMLElement>('[data-athlete-model-switcher]');
  previous?.remove();

  const style = resolveAthleteModelStyle();
  document.documentElement.dataset.athleteModel = style;
  const switcher = document.createElement('nav');
  switcher.className = 'athlete-model-switcher';
  switcher.dataset.athleteModelSwitcher = '';
  switcher.setAttribute('aria-label', 'Athlete model comparison');

  const label = document.createElement('span');
  label.textContent = 'ATHLETE MODEL';
  switcher.append(label);

  for (const candidate of ['realistic', 'legacy'] as const) {
    const link = document.createElement('a');
    link.href = athleteModelComparisonHref(window.location.href, candidate);
    link.textContent = candidate === 'realistic' ? 'ANATOMICAL' : 'ORIGINAL';
    if (candidate === style) link.setAttribute('aria-current', 'true');
    switcher.append(link);
  }

  document.body.append(switcher);
  return () => {
    switcher.remove();
    delete document.documentElement.dataset.athleteModel;
  };
};
